import "./EmptyCourses.css";
import UndrawCourses from "../../assets/empty-cursos.svg";
import Translatable from "../Translatable/Translatable";

function EmptyCourses() {
  return (
    <div className="calendar-image-container">
      <img className="cursos-image" src={UndrawCourses} alt="Sin cursos inscriptos" />
      <p className="empty-calendar-msg">
        <Translatable as="span">
          No estás inscripto en ninguna materia, selecciona tus materias para comenzar tu inscripción
        </Translatable>
      </p>
    </div>
  );
}

export default EmptyCourses;
